// extracted by mini-css-extract-plugin
export default {"title":"title--xJgD7","footer":"footer--Ld3He"};